export enum EReports {
  SUM = 'sum',
  POSITION = 'position',
  USER = 'user',
  REAL_ESTATE = 'realEstate',
  DEFECT = 'defect',
}

export enum EApplicationStatuses {
  NEW = 1,
  IN_PROGRESS = 2,
  DONE = 3,
  CLOSED = 6,
  REJECTED_BY_CLIENT = 8,
  REOPEN = 9,
}

export namespace GroupApplicationReport {
  export interface ICommon {
    count: number;
    left30min: number;
    left1hour: number;
    inProgress: number;
    done: number;
    closed: number;
    rejectByClient: number;
    reopen: number;
    delay: number;
    new: number;
  }

  export interface IPosition {
    count: number;
    left30min: number;
    left1hour: number;
    inProgress: number;
    done: number;
    closed: number;
    rejectByClient: number;
    reopen: number;
    delay: number;
    positionId: number;
    positionName: string;
    new: number;
  }

  export interface IUser {
    count: number;
    left30min: number;
    left1hour: number;
    inProgress: number;
    done: number;
    closed: number;
    rejectByClient: number;
    reopen: number;
    delay: number;
    positionId: number;
    positionName: string;
    userId: string;
    userName: string;
    new: number;
  }

  export interface IRealEstate {
    count: number;
    left30min: number;
    left1hour: number;
    inProgress: number;
    done: number;
    closed: number;
    rejectByClient: number;
    reopen: number;
    delay: number;
    realEstateId: string;
    realEstateName: string;
    new: number;
  }

  export interface IDefect {
    count: number;
    left30min: number;
    left1hour: number;
    inProgress: number;
    done: number;
    closed: number;
    rejectByClient: number;
    reopen: number;
    delay: number;
    defectId: number;
    defectName: string;
    new: number;
  }
}

export type GroupApplicationReportType =
  | GroupApplicationReport.ICommon
  | GroupApplicationReport.IDefect
  | GroupApplicationReport.IPosition
  | GroupApplicationReport.IRealEstate
  | GroupApplicationReport.IUser;

export interface IPosition {
  positionId: number;
  positionName: string;
}

export interface IRealEstate {
  addressKk: string;
  addressRu: string;
  guid: string;
  name: string;
}

export interface IDefect {
  defectName: string;
  defectTypeId: number;
}
